import { use, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import Routes from 'shared/enums/routes';
import AuthProviderContext from 'shared/features/auth/authentication/providers/contexts/auth-provider-context';

const useSigninRedirect = (): void => {
  const navigate = useNavigate();
  const auth = useAuth();
  const { permissions, backChannelLogoutIsLoading } = use(AuthProviderContext);

  useEffect(() => {
    const logInAfterLogoutAllSessions = (): void => {
      if (auth.isAuthenticated && auth.user && permissions.length > 0 && !backChannelLogoutIsLoading) {
        navigate(Routes.Default);
      }
    };
    logInAfterLogoutAllSessions();
  }, [auth.isAuthenticated, auth.user, permissions, backChannelLogoutIsLoading]);

  useEffect(() => {
    if (auth.error) {
      auth.removeUser();
      navigate(Routes.Login);
      return;
    }

    if (auth.isLoading) {
      return;
    }

    if (!auth.isAuthenticated || !auth.user || permissions.length === 0) {
      navigate(`${Routes.Login}?noAccess=true`);
    }
  }, [auth.isAuthenticated, auth.error, auth.isLoading]);
};

export default useSigninRedirect;
